import { createMiddleware } from "@tanstack/react-start";

/**
 * Compatibility client middleware for server functions migrated to native
 * Shields auth. The browser sends the HttpOnly same-origin session cookie
 * automatically; raw auth tokens are deliberately never copied into headers.
 */
export const attachShieldsAuth = createMiddleware({ type: "function" }).client(async ({ next }) => next());
